import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { User } from "../../../@types/user";

export const createUser = createAsyncThunk(
  "userCreate/createUser",
  async (user: User, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Content-Type", "application/json");

      let response = await fetch(`${api.baseURL}user`, {
        method: "POST",
        body: JSON.stringify(user),
        headers: headers,
      });
      if (!response.ok) {
        throw response.statusText;
      }
      let data: User = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
